import GcsDownloadProxyPage from '@/pages/GcsDownloadProxyPage.vue';
import { RouteNames } from '@/data/routes';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/download',
  name: RouteNames.GCS_DOWNLOAD_PROXY.INDEX,
  component: GcsDownloadProxyPage,
  meta: {
    displayNav: false,
    requiresAuth: false,
  },
});
